import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { Check, CheckCreateDto } from '../types/check';
import { CheckApiObject } from '../types/check-response';
import { CheckHistoryApiObject } from '../types/check-history-response';
import { CheckRegisterApiObject } from '../types/check-register-response';
import { CheckReportApiObject } from '../types/check-report-response';
import { Month } from '../types/period';

@Injectable({
  providedIn: 'root',
})
export class CheckHttpService {
  private http = inject(HttpClient);

  // ==========================================================================================
  // CREATE
  // ==========================================================================================

  public registerCheck$(employeeID: number, check: CheckCreateDto) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/journeys`;
    return this.http.post<CheckRegisterApiObject>(url, check, {
      observe: 'response',
    });
  }

  // ==========================================================================================
  // READ
  // ==========================================================================================

  public getChecks$(employeeID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks`;
    return this.http.get<CheckApiObject>(url, { observe: 'response', params });
  }

  public getCheck$(employeeID: number, checkId: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/${checkId}`;
    return this.http.get<CheckApiObject>(url, { observe: 'response' });
  }

  // ==========================================================================================
  // UPDATE
  // ==========================================================================================

  public updateCheck$(employeeID: number, checkID: number, check: Check) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/journeys/${checkID}`;
    return this.http.patch<CheckRegisterApiObject>(url, check, {
      observe: 'response',
    });
  }

  // ==========================================================================================
  // DELETE
  // ==========================================================================================

  public deleteCheck$(employeeID: number, checkID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/${checkID}`;
    return this.http.delete<CheckRegisterApiObject>(url, {
      observe: 'response',
    });
  }

  // ==========================================================================================
  // UTILS
  // ==========================================================================================

  public sendChecksReport$(employeeID: number, month: Month) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/pdf`;
    return this.http.patch<CheckReportApiObject>(url, month, {
      observe: 'response',
    });
  }

  public checkHistory$(companyID: number, employeeID: number, checkID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/checks/${checkID}/histories`;
    return this.http.get<CheckHistoryApiObject>(url);
  }
}
